import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import PETROLSIDE from "../../../assets/png/ENGINEERING.jpg";
import PETROLSIDE1 from "../../../assets/images/1500EFIImg/1500Enewdoors7.jpg";
import { useNavigate } from "react-router";
import PETROLModels from "../../../components/NZComponent/NzPetrol/PETROLModels";
import HighLevelSpecs from "../../../components/NZComponent/NzPetrol/HighLevelSpecs";
import NZNZPetrolGregFarrier from "../../../components/NZComponent/NzPetrol/NZNZPetrolGregFarrier";
import NZElectricaTV from "../../../components/NZComponent/NzPetrol/NZElectricaTV";
import NZElectricaATV from "../../../components/NZComponent/NzElectricAccessories/NZElectricaATV";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import NZElectricGregFarrier from "../../../components/NZComponent/home/NZElectricGregFarrier/NZElectricGregFarrier";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import NZElectricFeatures from "../../../components/NZComponent/NzElectricAccessories/NZElectricFeatures";
import NZElectricModels from "../../../components/NZComponent/NzElectricAccessories/NZElectricModels";
import NZElectricSafety from "../../../components/NZComponent/NzElectricAccessories/NZElectricSafety";
import NZElectricSpec from "../../../components/NZComponent/NzElectricAccessories/NZElectricSpec";
import SEOMetadata from "../../../components/SEOMetadata";
import { seoConfig } from "../../../config/seoConfig";
import NZElectricFAQ from "./NZElectricFAQ";

const NzElectricAccessories = () => {
  const seoData = seoConfig.nz.electricAccessories;
  let navigate = useNavigate();

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img
            src={HomeIcon}
            alt="HomeIcon"
            className="cursor-pointer"
            onClick={() => navigate("/")}
          />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`Electric`}</div>
        </div>
        <div className="grid lg:grid-cols-2 grid-cols-1 xl:gap-[50px] gap-[0px]">
          <div className="h-[310px] md:h-[720px] xl:h-[720px] lg:h-[500px] w-full">
            {/* <div
              className="h-[400px] w-full md:h-full"
              style={{
                backgroundImage: `url(${PETROLSIDE1})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            /> */}
            <div className="h-[310px] md:h-[720px] xl:h-[720px] lg:h-[500px] w-full">
              <img
                src={PETROLSIDE1}
                alt="Petrol Tuatara 1000 EFI side-by-side utility vehicle"
                className="w-full h-full object-cover border border-black"
              />
            </div>
          </div>
          <div className="p-[50px] md:pt-[100px] lg:pt-[20px] xl:pt-[100px]py-[20px] lg:p-[26px] xl:p-[50px]">
            <h1
              className="text-white kuunari-bold 
  text-[20px] 
  md:text-[40px] 
  lg:text-[40px]  
  xl:text-[60px]  
  leading-[32px]
  md:leading-[42px] 
  lg:leading-[56px]
  xl:leading-[62px]
  mb-[11px] 
  text-center 
  max-w-[511px] 
  mx-auto"
              style={{ textShadow: "2px 4px 6px #000000" }}
            >
              eTuatara 1500E Electric Side-by-Side Utility Vehicle
            </h1>

            <p className="text-[#666666] md:text-[20px] text-[16px] leading-[26px] lg:text-[15px] lg:leading-[21px] xl:text-[20px] xl:leading-[26px] text-center montserrat-medium py-4">
              The eTuatara is well suited to the farm environment given that it
              is very cheap to operate and maintain and can be charged at night.
              It has the added advantage over its combustion engine counterparts
              of developing full torque at any speed while a combustion engine
              may only develop full torque at 5000 rpm for example. This makes
              the eTuatara ideal for traversing steep inclines or for towing,
              but the greatest feature of the eTuatata is its versatility. This
              vehicle can be used for farming, horticulture, beekeeping, and
              even not non-agriculture activities, such as golf courses,
              retirement villages, forestry, parks, large gardens, airports,
              power stations and the list goes on.
            </p>
            <div className="text-center flex items-center justify-center flex-wrap">
              <button
                className="bg-[#6FBF4A] text-white px-6 py-3 font-semibold uppercase hover:opacity-90 transition"
                onClick={() => navigate("/nz/ContactUs")}
              >
                CONTACT US
              </button>
            </div>
            { }
            {/* <p className="text-[#666666] md:text-[20px] text-[16px] leading-[26px] text-center montserrat-medium">
              The cargo carrying and towing capacity, low running costs and simplicity make this highly versatile
              machine ideal for tackling your daily tasks. The eTuatara is designed to meet lifesyle, agricultural or
              commercial needs with a much smaller footprint than a conventional utility vehicle.
            </p> */}
          </div>
        </div>

        <div>
          <NZElectricFeatures />
          <NZElectricModels />
          <NZElectricSafety />
          <div className="bg-white pb-[60px]">
            <div className="max-w-[1200px] mx-auto px-[20px]">
              <h3 className="text-[28px] kuunari-bold text-center mb-[20px]">
                Key Benefits of the eTuatara 1500E
              </h3>

              <ul className="grid md:grid-cols-2 gap-4 text-[#666666] text-[16px] leading-[26px]">
                <li>✔ Low running and maintenance costs</li>
                <li>✔ Instant full torque at any driving speed</li>
                <li>✔ Ideal for steep inclines and heavy towing</li>
                <li>✔ Highly versatile for farming, horticulture, and commercial use</li>
                <li>✔ Convenient overnight charging capability</li>
                <li>✔ Remote battery diagnostics and software updates</li>
              </ul>

            </div>
          </div>
          <NZElectricSpec />


          {/* <NZElectricaATV /> */}
          {/* <NZElectricGregFarrier />
          <NZElectricaTV /> */}
        </div>
        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <NZElectricFAQ />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default NzElectricAccessories;
